module.exports = __webpack_public_path__ + "res/Roboto-Black-webfontd41d.eot?2a5b60f198bcc5a1f773be36a0e34185";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Black-webfontd41d.eot
// module id = 87
// module chunks = 0